import { AutenticacionService } from './autenticacion.service';
import { ErrorsService } from './tools/errors.service';
import { ValidatorService } from './tools/validator.service';
import { ConstantsService } from './constants.service';
import { Http, ResponseContentType } from '@angular/http';
import { Injectable } from '@angular/core';
declare var $;

@Injectable()
export class ConceptosService {
  public url:string;

  constructor(private http: Http, private constant: ConstantsService, private validatorService: ValidatorService, private errorService:ErrorsService, private authService: AutenticacionService) {
    this.url = constant.apiURL;
  }

  public getDefaultSchedule() {
    return {
      'idConceptos': '',
      'idTipo_Gasto': '',
      'idTipo_Ingreso': '',
      'idTipo_Movimiento': '',
      'idTipo_Clasificacion': '',
      'honorario': 1,
      'descripcion': '',
      'tipo_gasto': {},
      'tipo_ingreso': {},
      'tipo_movimiento': {},
      'tipo_clasificacion': {}
    };
  }

  public getTiposMovimiento() {
    return [
      {'idTipo_Movimiento':1, 'descripcion':'Egreso'},
      {'idTipo_Movimiento':2, 'descripcion':'Ingreso'},
      {'idTipo_Movimiento':3, 'descripcion':'Inversión'},
      {'idTipo_Movimiento':4, 'descripcion':'Traspaso'}
    ];
  }

  public getTiposClasificacion() {
    return [
      {'idTipo_Clasificacion':1, 'descripcion':'Accionista'},
      {'idTipo_Clasificacion':2, 'descripcion':'Oficina'},
      {'idTipo_Clasificacion':3, 'descripcion':'Proyecto'},
      {'idTipo_Clasificacion':4, 'descripcion':'Obra'},
      {'idTipo_Clasificacion':5, 'descripcion':'Retorno'},
      {'idTipo_Clasificacion':6, 'descripcion':'Honorario'},
    ];
  }

  public getTiposIngreso() {
    return [
      {'idTipo_Ingreso':0, 'descripcion':'Ninguno'},
      {'idTipo_Ingreso':1, 'descripcion':'Aportación'},
      {'idTipo_Ingreso':2, 'descripcion':'Aumento capital'},
      {'idTipo_Ingreso':3, 'descripcion':'Intereses'},
      {'idTipo_Ingreso':4, 'descripcion':'Rentas'},
      {'idTipo_Ingreso':5, 'descripcion':'Obra'},
      {'idTipo_Ingreso':6, 'descripcion':'Otros'}
    ];
  }

  public getTiposEgreso() {
    return [
      {'idTipo_Gasto':0, 'descripcion':'Ninguno'},
      {'idTipo_Gasto':1, 'descripcion':'Adquisición de inmuebles'},
      {'idTipo_Gasto':3, 'descripcion':'No aplica'},
      {'idTipo_Gasto':4, 'descripcion':'Obra'},
      {'idTipo_Gasto':5, 'descripcion':'Operativo'},
    ];
  }

  // objeto concepto simple
  public getConceptos(page) {

    // solo paginacion
    if (page) {
      return this.http.get(this.url + "/conceptos?paginate=true&page=" + page, this.authService.getAuthHeaders());
    }

      // solo conceptos
    return this.http.get(this.url + "/conceptos?paginate=true", this.authService.getAuthHeaders());
  }

  public getAllConceptos(){
    return this.http.get(this.url + "/conceptos?validarOrigen=false", this.authService.getAuthHeaders());
  }

  getConceptosByTipoMovimientoToSelect(idTipoMovimiento, preffix = '') {
    return this.http.get(this.url + preffix + '/conceptos?select=true&idTipoMovimiento=' + idTipoMovimiento, this.authService.getAuthHeaders());
  }

  // objecto para select
  public getConceptostoSelect(preffix = '') {
    return this.http.get(this.url + preffix + '/conceptos?select=true', this.authService.getAuthHeaders());
  }

  // buscar objeto simple
  public searchConceptos(search, page) {
    // buscar con paginacion
    if (page)
      return this.http.get(this.url + "/conceptos?paginate=true&search=" + search + "&page=" + page, this.authService.getAuthHeaders());

    // solo buscar
    return this.http.get(this.url + "/conceptos?paginate=true&search=" + search, this.authService.getAuthHeaders());
  }

  public createConcepto(data) {
    return this.http.post(this.url + '/conceptos', data, this.authService.getAuthHeaders());
  }

  public updateConcepto(data, id) {
    return this.http.put(this.url + '/conceptos?id=' + id, data, this.authService.getAuthHeaders());
  }

  public deleteConcepto(id) {
    return this.http.delete(this.url + '/conceptos/'+id, this.authService.getAuthHeaders());
  }

  public writePermission() {
    return this.authService.hasPermission(4, true);
  }

  public canExport() {
    return this.authService.canExport();
  }

  public export(search) {
    const options = this.authService.getAuthHeaders();
    options.responseType = ResponseContentType.Blob;
    return this.http.get(this.url + '/conceptos/exportar?search=' + search, options)
    .map((response) => {
      let link = document.createElement('a');
      link.href = window.URL.createObjectURL(response.blob());
      const contentDispositionHeader = response.headers.get('content-disposition');
      const result = contentDispositionHeader.split(';')[1].trim().split('=')[1];
      link.download = result.replace(/"/g, '');
      document.body.appendChild(link); 
      link.click();
      setTimeout(() => {
        link.remove();
      }, 200);
    });
  }

  public validateConcepto(data) {
    console.log('validating...', data);
    let error = [];
    // validacion de DESCRIPCION
    if (!this.validatorService.required(data['descripcion'])) {
      error['descripcion'] = this.errorService.required;
    } else if (!this.validatorService.max(data['descripcion'], 200)) {
      error['descripcion'] = this.errorService.max(200);
    }

    // validacion de TIPO MOVIMIENTO
    if ($.isEmptyObject(data['tipo_movimiento'])) {
      error['tipo_movimiento'] = this.errorService.required;
    }

    // validacion de TIPO CLASIFICACION
    if ($.isEmptyObject(data['tipo_clasificacion'])) {
      error['tipo_clasificacion'] = this.errorService.required;
    }

    return error;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/conceptos.service.ts